import { Fragment, useContext } from 'react'
import MenuExpedientes from '../components/MenuExpedientes'
import { ExpedientesContext } from '../providers/ExpedientesProvider'
import ExpedienteForm from './ExpedienteForm'
import ListadoExpedientes from './ListadoExpedientes'

const Expedientes = () => {
  const {
    active: { current },
    altaExpediente,
  } = useContext(ExpedientesContext)

  return (
    <Fragment>
      {!current ? (
        <MenuExpedientes />
      ) : current && !altaExpediente ? (
        <ListadoExpedientes />
      ) : (
        current && altaExpediente && <ExpedienteForm />
      )}
    </Fragment>
  )
}

export default Expedientes
